import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';

@Component({
  selector: 'app-ficha-lista',
  templateUrl: './ficha-lista.component.html',
  styleUrls: ['./ficha-lista.component.css']
})
export class FichaListaComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsEncuesta: DataTables.Settings = {};

  public dtTriggerEncuesta: Subject<any>;

  // public vecVerEncuestas = []; public terminos: string = ''; public chbAcepta: boolean = false; public vecAddResponde = []; private fechaHoy: string = '';

  // constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
  //   private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router) { }

  public vecVerEncuestas: Array<any>; vecPeriodo: Array<any> = []; vecMatricula: Array<any> = []; vecAddResponde: Array<any> = [];
  public terminos: string = ''; public chbAcepta: boolean = false;
  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private srvGeneral: recursosCompartido,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router) {
    this.vecMatricula.push({ banMatricula: false }); this.vecPeriodo.push({ estado: false })
  }

  ngOnInit() {
    // this.calculoFecha();
    // this.dtTriggerEncuesta = new Subject<any>();

    // this.dtOptionsEncuesta[0] = this.tools.OpcionesTabla(10);
    // this.verEncuestas();

    this.dtTriggerEncuesta = new Subject<any>();
    this.dtOptionsEncuesta[0] = this.tools.OpcionesTabla(10);
    this.verEstadoMatricula();
  }
  async verEstadoMatricula() {
    this.vecPeriodo = await this.srvGeneral.verPeriodoVigente();
    //VERIFICAR EL PERIODO VIGENTE A LA FECHA
    if (this.vecPeriodo[0].estado) {
      this.vecMatricula = await this.srvGeneral.verDataMatricula('', this.vecPeriodo[0].periodo[0].strCodigo, localStorage.getItem('ciUsuario'))

      if (this.vecMatricula[0].banMatricula) {
        this.verCuestionarios(localStorage.getItem('ciUsuario'), this.vecPeriodo[0].periodo[0].strCodigo);
      }
    }
    else
      this.alerti.error('A la fecha no hay un período académico vigente');

  }

  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  async verCuestionarios(estudiante, periodo) {
    var table2 = $('#tblGrupo').DataTable({
      destroy: true
    });
    table2.destroy();
    this.cargando.abrir();
    this.vecVerEncuestas = [];
    const resFicha = await new Promise<any>(resolve =>
      this.srvSelect.obtenerGestionFichaEstudiante(9, estudiante, periodo, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resFicha.resultado) {
      this.vecVerEncuestas = resFicha.fichaEstudiantil;
      this.dtTriggerEncuesta.next();
    }
    else
      this.alerti.message('No se encntró información de encuestas registradas');
    this.cargando.cerrar();
  }
  //ABRIR EL MODAL DE TERMINOS Y CONDICIONES
  async verTerminos(nombModal, encuesta) {
    const resMatricula = await new Promise<any>(resolve =>
      this.srvSelect.gestionMatricula(34, localStorage.getItem('localBaseCarrera'), localStorage.getItem('ciUsuario'), localStorage.getItem('localEstudiante'),
        localStorage.getItem('localPeriodo')).subscribe(translated => {
          resolve(translated)
        }));

    if (resMatricula.success) {
      this.terminos = encuesta.strTerminos;
      this.vecAddResponde.push({ encuesta });
      this.mr = this.modalService.open(nombModal);
    }
    else
      this.alerti.error('Ficha no disponible, por favor vuelva cargar el sistema');
  }
  //ABRE EL FORMULARIO PARA EL REGISTRO DE REQUISITOS
  async aceptaTerminos() {
    if (this.chbAcepta) {
      let dataNavega = navigator.userAgent;
      let dataCentral = await this.srvGeneral.genObtenerDataPersonaCentral(localStorage.getItem('ciUsuario'))
      if (this.vecMatricula[0].banMatricula && this.vecPeriodo[0].estado && dataCentral[0].estado) {

        let idResponde = this.vecMatricula[0].matricula[0].cedEstudiante + '_' + this.vecPeriodo[0].periodo[0].strCodigo + '_' + this.vecAddResponde[0].encuesta.intIdEncuesta;
        this.srvInsert.registroGestionFicha(idResponde, dataCentral[0].documento, dataCentral[0].nombres, dataCentral[0].apellidos, dataCentral[0].sexo,
          this.vecMatricula[0].matricula[0].codCarrera, this.vecMatricula[0].matricula[0].nombCarrera, this.vecMatricula[0].matricula[0].codFacultad,
          this.vecMatricula[0].matricula[0].nombFacultad, dataNavega, this.vecAddResponde[0].encuesta.intIdEncuesta, this.vecPeriodo[0].periodo[0].strCodigo,
          2, 'na', 'na', 6).subscribe(resResp => {
            if (resResp.respFicha) {
              localStorage.setItem('lclResFicha', idResponde); this.mr.close();
              this.ruta.navigate(["/becario/fichaEstudianteResponde"]);
            }
            else
              this.alerti.error('Error inesperado vuelva a intentar más tarde');
          });
      }
      else
        this.alerti.error('Error inesperado vuelva a intentar más tarde');
    }
    else
      this.alerti.error('Debe aceptar los términos y condiciones antes de continuar');
  }
  verRespuestas(objRes) {
    localStorage.setItem('lclResFicha', objRes.idResponde);
    this.ruta.navigate(["/becario/fichaEstudianteResponde"]);
  }














  // //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS REGISTRADOS
  // async verEncuestas() {
  //   var table2 = $('#tblEncuesta').DataTable({
  //     destroy: true
  //   });
  //   table2.destroy();
  //   if (localStorage.getItem('localPeriodo') == 'na')
  //     this.alerti.error('No se encontró una matrícula vigente o actualice su navegador para cargar sus datos');
  //   else {
  //     this.cargando.abrir();
  //     this.vecVerEncuestas = [];
  //     const resGrupo = await new Promise<any>(resolve =>
  //       this.srvSelect.gestionEncuesta(10, 'na', 'na', 'na', 'na').subscribe(translated => {
  //         resolve(translated)
  //       }));
  //     if (resGrupo.success) {
  //       for (let objEnc of resGrupo.encuesta) {
  //         if (objEnc.intEstado == 1) {
  //           const resResp = await new Promise<any>(resolve =>
  //             this.srvSelect.gestionEncuesta(14, localStorage.getItem('ciUsuario'), objEnc.intIdEncuesta,
  //               localStorage.getItem('localPeriodo'), 'na').subscribe(translated => {
  //                 resolve(translated)
  //               }));

  //           if (resResp.success) {
  //             this.vecVerEncuestas.push({
  //               intIdEncuesta: resResp.encuesta[0]['intEncuesta'],
  //               strNombre: resResp.encuesta[0]['strNombreEnc'],
  //               strDescripcion: resResp.encuesta[0]['strTerminos'],
  //               strRecomendacion: resResp.encuesta[0]['strRecomendacionEnc'],
  //               strTerminos: resResp.encuesta[0]['strTerminos'],
  //               intPersona: resResp.encuesta[0]['strEstudiante'],
  //               datFecha: resResp.encuesta[0]['datFecha'],
  //               intEstado: resResp.encuesta[0]['intEstado'],
  //               tipo: resResp.encuesta[0]['intEstado'],
  //               numResponde: resResp.encuesta[0]['intIdResponde']
  //             });
  //           }
  //           else {
  //             this.vecVerEncuestas.push({
  //               intIdEncuesta: objEnc.intIdEncuesta,
  //               strNombre: objEnc.strNombre,
  //               strDescripcion: objEnc.strDescripcion,
  //               strRecomendacion: objEnc.strRecomendacion,
  //               strTerminos: objEnc.strTerminos,
  //               intPersona: objEnc.intPersona,
  //               datFecha: objEnc.datFecha,
  //               intEstado: objEnc.intEstado,
  //               tipo: 0,
  //               numResponde: objEnc.intIdResponde
  //             });
  //           }
  //         }
  //       }
  //     }
  //     this.dtTriggerEncuesta.next();
  //     this.cargando.cerrar();
  //   }
  // }
  // //ABRIR EL MODAL DE TERMINOS Y CONDICIONES
  // async verTerminos(nombModal, encuesta) {
  //   const resMatricula = await new Promise<any>(resolve =>
  //     this.srvSelect.gestionMatricula(34, localStorage.getItem('localBaseCarrera'), localStorage.getItem('ciUsuario'), localStorage.getItem('localEstudiante'),
  //       localStorage.getItem('localPeriodo')).subscribe(translated => {
  //         resolve(translated)
  //       }));

  //   if (resMatricula.success) {
  //     this.terminos = encuesta.strTerminos;
  //     this.vecAddResponde = encuesta;
  //     this.mr = this.modalService.open(nombModal);
  //   }
  //   else
  //     this.alerti.error('Ficha no disponible, por favor vuelva cargar el sistema');
  // }
  // //IR A LA RESPUESTA DE UNA FICHA REALIZADA
  // async verRespuestas(respuesta, opc) {
  //   const resMatricula = await new Promise<any>(resolve =>
  //     this.srvSelect.gestionMatricula(34, localStorage.getItem('localBaseCarrera'), localStorage.getItem('ciUsuario'), localStorage.getItem('localEstudiante'),
  //       localStorage.getItem('localPeriodo')).subscribe(translated => {
  //         resolve(translated)
  //       }));
  //   if (resMatricula.success) {
  //     localStorage.setItem('localResponde', respuesta.numResponde);
  //     localStorage.setItem('localNumEnc', respuesta.intIdEncuesta);
  //     localStorage.setItem('localNumInt', '2');
  //     if (opc == 1)
  //       this.ruta.navigate(["/becario/verResultado"]);
  //     if (opc == 2) {
  //       this.srvInsert.ingresoEncuesta(respuesta.numResponde, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 92).subscribe(res => {
  //         if (res.encuesta)
  //           this.ruta.navigate(["/becario/fichaEstudiante"]);
  //       });
  //     }
  //   }
  //   else
  //     this.alerti.error('vuelva a carga la página por favor');
  // }
  // //ABRE EL FORMULARIO PARA EL REGISTRO DE REQUISITOS
  // async aceptaTerminos() {
  //   const resMatricula = await new Promise<any>(resolve =>
  //     this.srvSelect.gestionMatricula(2, localStorage.getItem('localBaseCarrera'), localStorage.getItem('ciUsuario'), localStorage.getItem('localPeriodo'),
  //       'na').subscribe(translated => {
  //         resolve(translated)
  //       }));
  //   if (resMatricula.success) {
  //     if (this.chbAcepta) {
  //       if (localStorage.getItem('localEstudiante') != 'na' && localStorage.getItem('localCarrera') != 'na' && localStorage.getItem('localPeriodo') != 'na') {

  //         let dataNavega = navigator.userAgent;
  //         this.srvInsert.ingresoEncuesta(localStorage.getItem('localCarrera'), localStorage.getItem('ciUsuario'), localStorage.getItem('localEstudiante'),
  //           this.vecAddResponde['intIdEncuesta'], this.vecAddResponde['strNombre'], this.vecAddResponde['strRecomendacion'], this.vecAddResponde['strTerminos'],
  //           localStorage.getItem('localPeriodo'), localStorage.getItem('localFacultad'), dataNavega, 91).subscribe(res => {
  //             if (res.encuesta) {
  //               this.verUltimoResponde();
  //             }
  //             else
  //               this.alerti.error('Debe aceptar los términos y condiciones antes de continuar');
  //           });
  //       }
  //       else
  //         this.alerti.error('El estudiante no tiene matrícula vigente o actualice la página');
  //     }
  //     else
  //       this.alerti.error('Debe aceptar los términos y condiciones antes de continuar');
  //   }
  //   else
  //     this.alerti.error("No se encontró información referente a matrículas vigentes, vuelva a cargar la página");
  // }
  // //BUSCAR LA ULTIMA ENCUESTA REGISTRADA PARA OBTENER EL ID
  // async verUltimoResponde() {
  //   const resResponde = await new Promise<any>(resolve =>
  //     this.srvSelect.gestionEncuesta(13, localStorage.getItem('ciUsuario'), 'na', 'na', 'na').subscribe(translated => {
  //       resolve(translated)
  //     }));
  //   if (resResponde.success) {
  //     this.irEncuesta(resResponde.encuesta);
  //   }
  // }
  // //IR A LA ENCUESTA A RES RESPONDIDA
  // irEncuesta(encuesta) {
  //   this.cerrarModal();
  //   localStorage.setItem('localResponde', encuesta[0]['intIdResponde']);
  //   localStorage.setItem('localNumEnc', this.vecAddResponde['intIdEncuesta']);
  //   localStorage.setItem('localNumInt', '1');
  //   this.ruta.navigate(["/becario/fichaEstudiante"]);
  // }
  // //FUNCION QUE CIERRA EL MODAL
  // cerrarModal() {
  //   this.mr.close();
  // }
  // //FUNCION QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  // calculoFecha() {
  //   var hoy = new Date();
  //   var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
  //   var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
  //   var aniohoy = hoy.getFullYear();
  //   this.fechaHoy = aniohoy + "-" + meshoy + "-" + diahoy;
  // }

}
